<app-dialog [showInnerCard]="false">
  <app-dialog-title>
    {{ currentRequest?.[myenv.Attributes.DisplayName] }}
  </app-dialog-title>
  <app-dialog-subtitle>
    @if (currentRequest) {
      {{ currentRequest[myenv.Attributes.CreatedTime] | timeAgo | async }} &bull;
      {{ getCreator(currentRequest[myenv.Attributes.Creator]) | async }}
    }
  </app-dialog-subtitle>
  <app-dialog-header-button>
    {{ currentRequestIndex + 1 }}
    <language key="DatatableOf" defaultValue="of"></language>
    {{ requests.length }}
  </app-dialog-header-button>
  <button app-dialog-header-button mat-icon-button (click)="dialogRef.close(null)">
    <mat-icon>close</mat-icon>
  </button>
  @if (loading) {
    <mat-card appearance="raised" class="inner-card">
      <div class="loader" mat-dialog-content>
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    </mat-card>
  } @else if (requests.length === 0) {
    <mat-card appearance="raised" class="inner-card">
      <div mat-dialog-content>
        <h4>
          <language
            key="RequestDialogNonPending"
            defaultValue="No pending request was selected."
          ></language>
        </h4>
      </div>
    </mat-card>
  } @else {
    <mat-card appearance="raised" class="inner-card request-content">
      <div mat-dialog-content class="">
        <request-summary-control
          [request]="currentRequest"
          (openDetail)="openDetail($event)"
        ></request-summary-control>
      </div>
    </mat-card>
    <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ reasonCaption }}</mat-label>
      <textarea
        matInput
        rows="1"
        [(ngModel)]="reason"
        [disabled]="requests.length === 0 || loading"
      ></textarea>
      @if (reason) {
        <button matSuffix matIconButton aria-label="Clear" (click)="reason = ''">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  <app-dialog-action-button
    [disabled]="requests.length === 0 || loading"
    (click)="submit('approve')"
  >
    <language key="RequestApproveButton" defaultValue="Approve"></language>
  </app-dialog-action-button>
  <app-dialog-action-button
    [disabled]="requests.length === 0 || loading"
    (click)="submit('reject')"
  >
    <language key="RequestRejectButton" defaultValue="Reject"></language>
  </app-dialog-action-button>
  <app-dialog-action-button [disabled]="requests.length === 0 || loading" (click)="skip()">
    <language key="RequestSkipButton" defaultValue="Skip"></language>
  </app-dialog-action-button>
</app-dialog>
